import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CPassoword } from '@core/models/login';
import { changedPassword, serverError } from '@core/models/messages';
import { MustMatch } from '@core/models/must-match-validator';
import { patternPassword } from '@core/models/pattern';
import { AuthService } from '@core/services/auth-service/auth.service';
import { environment } from '@env/environment';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-init-password',
  templateUrl: './init-password.component.html',
  styleUrls: ['./init-password.component.css']
})
export class InitPasswordComponent {

  env = environment
  
  /* formGroup */
  generateResePasswordForm: FormGroup = this.resetPasswordForm(
    new CPassoword()
  );
  /* string */
  showPassword: string = 'password';
  showConfirmPassword: string = 'password';
  userEmail!: string;
  /* boolean */
  loadSpinner: boolean = false;
  token?:string; 
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  term: any;
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private reCaptchaService: ReCaptchaService,
  ) {}
  ngOnInit() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.token = params.params['token'];
      }
    })
  }
  touchedPass() {
    this.generateResePasswordForm.markAllAsTouched();
    this.generateResePasswordForm.markAsDirty();
  }

  /* create resetPassword form */
  resetPasswordForm(data: any) {
    return this.formBuilder.group(
      {
        newPassword: [
          data?.newPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
        confirmPassword: [
          data?.confirmPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
        terme: [data.terme, [Validators.required]],
        newsLetter: [data.newsLetter? data.newsLetter : false],
        telAssistance: [data.telAssistance? data.telAssistance : false],
      },
      { validator: MustMatch('newPassword', 'confirmPassword') }
    );
  }

  /* send new password   */
  resetPassword() {   
    if (this.generateResePasswordForm.valid) {
      this.reCaptchaService.executeAction('initPassword').then(token => {
        this.spinner.show();
        this.loadSpinner = true;
        let payload: any = {
          t_uuid: this.token,
          newPassword: this.generateResePasswordForm.get('newPassword')?.value,
          terme: this.generateResePasswordForm.get('terme')?.value,
          newsLetter: this.generateResePasswordForm.get('newsLetter')?.value,
          telAssistance: this.generateResePasswordForm.get('telAssistance')?.value,
          isNew: true,
          recaptchaToken: token
        };

      this.authService
        .restPassword(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide()
            this.loadSpinner = false;
            if (res.status == 200) {
              this.toastrService.success(changedPassword);
              this.router.navigate(['/auth/login']);
            }
          },
          error: () => {
            this.spinner.hide()
            this.loadSpinner = false;
            this.toastrService.error(serverError);
          },
        });
    }).catch(err => {
      this.spinner.hide();
      this.toastrService.error('reCAPTCHA verification failed. Please try again.'); // Optional
    });
   }

  }

  terms(){
    this.term=this.generateResePasswordForm.get("terme")?.value;
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
